export const hostUrl = "https://api.us.amity.co/api"
export default hostUrl;